import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { S_Card } from '../../../../../design/card/card/S_Cards';
import { S_ClipLoader } from '../../../../../design/loaders/clipLoader/S_ClipLoader';
import { ConfirmationStatus } from '../../containers/ConfirmEmailContainer';

interface IProps {
  confirmationStatus: ConfirmationStatus;
  onGoToLoginClick: () => void;
}

export const ConfirmNewEmail = ({ confirmationStatus, onGoToLoginClick }: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <S_Card className='account-activation'>
      <div className='header'>
        {confirmationStatus === 'InProgress' && t('confirming_email')}
        {confirmationStatus === 'Success' && t('email_confirmation_success')}
        {confirmationStatus === 'Failed' && t('email_confirmation_failed')}
      </div>
      <div className='content'>
        {confirmationStatus === 'InProgress' && (
          <S_ClipLoader
            color='var(--joy-palette-neutral-600)'
            size={48}
          />
        )}
        {confirmationStatus === 'Success' && (
          <div className='auth-link'>
            {t('email_confirmation_success_description')}
            <a
              href='#'
              onClick={onGoToLoginClick}
            >
              {t('here')}
            </a>
            .
          </div>
        )}
        {confirmationStatus === 'Failed' && t('email_confirmation_failed_description')}
      </div>
    </S_Card>
  );
};
